import React, { useEffect, useState } from 'react';
import '../styles/HomePage.css';
// import LogoCard from '../components/Logo-card.js';
import CardQVEMA from '../components/CardQVEMA.js';
// import QuizCard from '../components/Quiz-card.js';
// import CorpoVidCard from '../components/CorpoVid-card.js';
import ProductCard from '../components/ProductCard.js'
// import VideoSliderLine from '../components/VideoSliderLine.js';
import MediaLogos from '../components/MediaLogos.js';
import CustomerReviews from '../components/CustomerReviews.js';
import LoadingDots from '../components/LoadingDots.js';
// import Disclaimer from '../components/Disclaimer.js';
// import ArticleSlider from '../components/ArticleSlider.js';
import VideoSlider from '../components/VideoSlider.js';
import Loader from '../components/Loader.js';
// import VideoBanner from '../components/VideoBanner.js';
import { Send } from "lucide-react";
import {emailListing} from "../apis/apiBaltee.js"
// import { ChevronDown } from 'lucide-react';
import Reassurance from '../components/Reassurance.js';

// import { MoveRight } from "lucide-react";

import { stripeProductsAPI, stripeProductPricesAPI } from '../apis/apiStripe.js'

const HomePage = () => {
  const [B01, setB01] = useState({});
  const [B01LITE, setB01LITE] = useState(false);
  const [H01, setH01] = useState(false);
  const [FIX, setFIX] = useState(false);
  const [loader, setLoader] = useState(true);
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProductB01LITE, setSelectedProductB01LITE] = useState(null);
  const [selectedProductB01, setSelectedProductB01] = useState(null);
  const [selectedProductH01, setSelectedProductH01] = useState(null);
  const [email, setEmail] = useState("");
  const [showFormGame, setShowFormGame] = useState(!localStorage.getItem("played"));
  const [submitFormGame, setSubmitFormGame] = useState(false);
  // const [selectedProductFIX, setSelectedProductFIX] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const productsResponse = await stripeProductsAPI();
        if (!productsResponse || !productsResponse.data) {
          return console.warn("Aucun produit trouvé.");
        }
    
        // On ne conserve que les produits actifs
        const activeProducts = productsResponse.data.filter(product => product.active);
        
        // Formatage des produits avec récupération de leurs prix (si default_price existe)
        const formattedProducts = await Promise.all(
          activeProducts.map(async (product) => {
            const priceData = product.default_price
              ? await stripeProductPricesAPI(product.id)
              : null;
    
            return {
              productId: product.id,
              name: product.name,
              description: product.description,
              image: product.images && product.images.length > 0 ? product.images[0] : null,
              metadata: product.metadata,
              created: product.created,
              updated: product.updated,
              price: priceData,
            };
          })
        );
    
        // Fonction utilitaire pour filtrer les prix actifs
        const filterActivePrices = (product) => ({
          ...product,
          price: {
            ...product.price,
            data: product.price?.data?.filter(price => price.active) || []
          }
        });
    
        const productsWithActivePrices = formattedProducts.map(filterActivePrices);
    
        const filterProductsByRef = (ref) =>
          productsWithActivePrices.filter(product => product.metadata.ref === ref);
    
        const filteredProductsB01 = filterProductsByRef("B01");
        const filteredProductsB01LITE = filterProductsByRef("B01LITE");
        const filteredProductsH01 = filterProductsByRef("H01");
        const filteredProductsFIX = filterProductsByRef("FIX");

        const ProductsB01 = {bgVideo: '/assets/backgrounds/videos/bg-5.mp4', data: filteredProductsB01};
        const ProductsB01LITE = {bgVideo: '/assets/backgrounds/videos/bg-2.mp4', data: filteredProductsB01LITE};
        const ProductsH01 = {bgVideo: '/assets/backgrounds/videos/bg-3.mp4', data: filteredProductsH01};
        const ProductsFIX = {bgVideo: '/assets/backgrounds/videos/bg-3.mp4', data: filteredProductsFIX};

        // console.log('Products B01', ProductsB01);
        // console.log('Products B01 LITE', ProductsB01LITE);
        // console.log('Products H01', ProductsH01);

        setB01(ProductsB01);
        setB01LITE(ProductsB01LITE);
        setH01(ProductsH01);
        setFIX(ProductsFIX);
        setLoader(false);

        const defaultColor = "BLACK";

        const defaultProductB01 = filteredProductsB01.find(
          (product) => product.metadata.color === defaultColor
        );
        const defaultProductB01LITE = filteredProductsB01LITE.find(
          (product) => product.metadata.color === defaultColor
        );
        const defaultProductH01 = filteredProductsH01.find(
          (product) => product.metadata.color === defaultColor
        );
        // const defaultProductFIX = filteredProductsFIX.find(
        //   (product) => product.metadata.color === defaultColor
        // );

        // S’il n’y a pas de produit pour cette couleur, on prend le premier
        setSelectedProductB01(defaultProductB01 || filteredProductsB01[1]);
        setSelectedProductB01LITE(defaultProductB01LITE || filteredProductsB01LITE[0]);
        setSelectedProductH01(defaultProductH01 || filteredProductsH01[0]);
        // setSelectedProductFIX(defaultProductFIX || filteredProductsFIX[0]);
    
      } catch (error) {
        console.error("Erreur lors de la récupération des produits Stripe :", error);
      }
    };    
  
    fetchProducts();
  }, []);

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   console.log("Email soumis:", email);
  //   setSubmitFormGame(true);
  //   emailListing({email: email, source: 'GAME'});
  //   setTimeout(() => {      
  //     setShowFormGame(false);
  //     localStorage.setItem("played", true);
  //   }, 2000);
  // };

  // const openModal = () => {
  //   setIsModalOpen(true);
  // };
  
  // const closeModal = () => {
  //   setIsModalOpen(false);
  // };
  
  const handleProductSelectedB01 = (product) => {
    setSelectedProductB01(product);
  };
  const handleProductSelectedB01LITE = (product) => {
    setSelectedProductB01LITE(product);
  };
  const handleProductSelectedH01 = (product) => {
    setSelectedProductH01(product);
  };
  return (
    <div>
    {
      !loader ? 
      <div style={{backgroundColor: "#F5F5F7"}}>
        <div className="home-container mobile">
          
          <br />
           { H01.data && H01.bgVideo ? <ProductCard products={H01} forcedColor={selectedProductH01?.metadata?.color} onProductSelected={handleProductSelectedH01} newProduct={true} backgroundVideoEnabled={false} modeColor="blue"/> : <Loader />  }

          <br />
          { B01LITE.data && B01LITE.bgVideo ? <ProductCard newProduct={true} products={B01LITE} forcedColor={selectedProductB01LITE?.metadata?.color} onProductSelected={handleProductSelectedB01LITE} backgroundVideoEnabled={false} modeColor="blue" /> : <Loader />  }
          <br />
          { B01.data && B01.bgVideo ? <ProductCard products={B01} cred={true} forcedColor={selectedProductB01?.metadata?.color} onProductSelected={handleProductSelectedB01} backgroundVideoEnabled={false} modeColor="blue" /> : <Loader />  }

          <div style={{ borderRadius: 28, padding: '20px', margin: '20px',textAlign: 'left' }}>
            <h2 style={{textTransform: 'uppercase'}}>
            Satisfait ou remboursé, essayez pendant 90 jours !
            </h2>
            <p>Profitez de notre offre "Satisfait ou remboursé" : Essayez pendant 90 jours, si vous n’êtes pas pleinement satisfait, nous vous remboursons intégralement !</p>
            <Reassurance />
          </div>

          <div style={{marginLeft: 20, marginRight: 20}}>
            <h1 style={{fontWeight: 900}}>Baltee mobility révolutionne la sécurité à vélo et trottinette.</h1>
            <p>Nous concevons des accessoires innovants pour protéger les cyclistes et utilisateurs de trottinettes au quotidien. Adoptez une mobilité plus sûre avec Baltee !</p>
          </div>
          <br />
          <CardQVEMA imageUrl="/assets/other/qvema_8.png" />
          <CustomerReviews />
          <br />
          
          <br />
          { FIX.data && FIX.bgVideo ? <ProductCard productIcon={false} products={FIX} cred={true} backgroundVideoEnabled={false} modeColor="blue" discover={false} /> : <Loader />  }
          <br />
           
          {/* <div style={{backgroundColor: '#bbe2d2', padding: 20, borderRadius: 28, marginInline: 20, width: '90%', margin: '20px auto'}}>
            <div style={{padding: '20px 10px 10px 10px', borderRadius: 28, marginInline: 10}}>
              {showFormGame ? 
              <div>
                <h3 style={{margin: 0, color: "#fff", fontSize: 20}}>
                  Tentez de gagner immédiatement un <span style={{fontWeight: 900, fontSize: 20, color: "#333"}}>B01 Black</span> ou <span style={{fontWeight: 900, fontSize: 20, color: "#333"}}>H01 Black</span> ou un <span style={{fontWeight: 900, fontSize: 20, color: "#333"}}>Code promo</span> 🤩
                </h3>
                <p style={{color: "rgba(0, 0, 0, 0.8)"}}>Entrez votre email ci-dessous pour tenter votre chance.</p> 
              </div>
              : 
              <div>
                <h2 style={{color: "#FFF", marginBottom: 0}}>Vous avez gagnez un code <strong>promo de -5%</strong> 
                </h2>
                <p style={{color: "rgba(0, 0, 0, 0.8)"}}>Cumulable avec les offres actuelles !</p>
                <h2 style={{margin: 0, color: "#fff"}}>
                  CODE : <span style={{color: "#000"}}>EMISSION5</span>
                </h2>
                <br />
                <small><i>Le code est à saisir au moment de la page de paiement</i>.</small>
              </div>}
              {showFormGame && !submitFormGame ? <div className="email-form-container">
                <form onSubmit={handleSubmit} className="email-form">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Entrez votre email"
                    className="email-input"
                    required
                  />
                  <button type="submit" className="send-button">
                    <Send size={24} />
                  </button>
                </form>
              </div> : null}
              {
                submitFormGame && showFormGame ? 
                <div>
                  <br />
                  <LoadingDots />
                  <br />
                </div> : null
              }
            </div>
          </div> */}
          <br />
          <hr style={{width: '80%', margin: '0 auto'}}></hr>
          
          <p style={{fontSize: 40, margin: '40px 20px 0px 20px', color: "#333", fontWeight: 700}}>Prix innovation Sécurité routière 2025</p>
          <br />
          <br />

          <div
            style={{borderRadius: 28, overflow: "hidden", width: '90%', margin: '0 auto'}}
          >
            <iframe width="100%" height="315" src="https://www.youtube-nocookie.com/embed/uxGGTYpAGuU?si=85h2J-oEnfzViVdC&amp;controls=0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
          </div>
          <br />
          <br />
       
          <p style={{fontSize: 40, margin: '0px 20px 0px 20px', color: "#333", fontWeight: 700}}>On parle de nous !</p>
          <VideoSlider />
          <MediaLogos />
          <br />
         
        </div>
{/* //////////////////////////////////////////////// */}
        <div className="home-container desktop"> 
          {/* style={{maxWidth: "1200px", margin: "0 auto" }} */}
          <br/>
          <div className='desktop-block-2' style={{width: '94%', margin: '0 auto', alignItems: 'stretch'}}>
          { B01LITE.data && B01LITE.bgVideo ? <ProductCard products={B01LITE} newProduct={true} forcedColor={selectedProductB01LITE?.metadata?.color} onProductSelected={handleProductSelectedB01LITE} backgroundVideoEnabled={false} modeColor="blue" /> : <Loader />  }
          { B01.data && B01.bgVideo ? <ProductCard products={B01} cred={true} forcedColor={selectedProductB01?.metadata?.color} onProductSelected={handleProductSelectedB01} backgroundVideoEnabled={false} modeColor="blue" /> : <Loader />  }
          </div>

          <div className='desktop-block-2' style={{width: '90%', margin: '0 auto'}}>
            { H01.data && H01.bgVideo ? <ProductCard products={H01} forcedColor={selectedProductH01?.metadata?.color} onProductSelected={handleProductSelectedH01} newProduct={true} backgroundVideoEnabled={false} modeColor="blue"/> : <Loader />  }
            { FIX.data && FIX.bgVideo ? <ProductCard productIcon={false} products={FIX} cred={true} backgroundVideoEnabled={false} modeColor="blue" discover={false} /> : <Loader />  }
          </div>

          <div className='desktop-block-2' style={{width: '90%', margin: '0 auto'}}>
            <a rel="noreferrer" href='https://www.m6.fr/qui-veut-etre-mon-associe-la-suite-p_21204' target='_blank'><img style={{borderRadius: 28, overflow: 'hidden', width: '90%'}} src="/assets/other/qvema_8.png" alt="Logo"/></a>
            <div style={{marginLeft: 20, marginRight: 20, textAlign: 'left'}}>
                <div style={{ borderRadius: 28, padding: '20px', margin: '20px',textAlign: 'left' }}>
                <h2 style={{textTransform: 'uppercase'}}>
                Satisfait ou remboursé, essayez pendant 90 jours !
                </h2>
                <p>Profitez de notre offre "Satisfait ou remboursé" : Essayez pendant 90 jours, si vous n’êtes pas pleinement satisfait, nous vous remboursons intégralement !</p>
                <Reassurance />
              </div>
              <h1 style={{fontWeight: 900}}>Baltee mobility révolutionne la sécurité à vélo et trottinette.</h1>
              <p>Nous concevons des accessoires innovants pour protéger les cyclistes et utilisateurs de trottinettes au quotidien. Adoptez une mobilité plus sûre avec Baltee !</p>
              <img src="/assets/products/B01_3-4_R.png" style={{width: '70%', margin: '0 auto'}}  alt="B01"/>
            </div>
          </div>
          
          <br />
          
          {/* <div className='desktop-block-2' style={{width: '90%', margin: '0 auto'}}>
            <div style={{backgroundColor: '#bbe2d2', padding: 20, borderRadius: 28, marginInline: 20, width: '100%', margin: '20px auto'}}>
              <div style={{padding: '20px 10px 10px 10px', borderRadius: 28, marginInline: 10}}>
                {showFormGame ? 
                <div>
                  <h3 style={{margin: 0, color: "#fff", fontSize: 20}}>
                    Tentez de gagner immédiatement un <span style={{fontWeight: 900, fontSize: 20, color: "#333"}}>B01 Black</span> ou un <span style={{fontWeight: 900, fontSize: 20, color: "#333"}}>Code promo</span> 🤩
                  </h3>
                  <p style={{color: "rgba(0, 0, 0, 0.8)"}}>Entrez votre email ci-dessous pour tenter votre chance.</p> 
                </div>
                : 
                <div>
                  <h2 style={{color: "rgba(0, 0, 0, 1)", marginBottom: 0}}>Vous avez gagnez un code <strong>promo de -5%</strong> 
                  </h2>
                  <p style={{color: "rgba(0, 0, 0, 0.8)"}}>Cumulable avec les offres actuelles !</p>
                  <h2 style={{margin: 0, color: "#fff"}}>
                    CODE : <span style={{color: "#fff"}}>EMISSION5</span>
                  </h2>
                  <br />
                  <small><i>Le code est à saisir au moment de la page de paiement</i>.</small>
                </div>}
                {showFormGame && !submitFormGame ? <div className="email-form-container">
                  <form onSubmit={handleSubmit} className="email-form">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Entrez votre email"
                      className="email-input"
                      required
                    />
                    <button type="submit" className="send-button">
                      <Send size={24} />
                    </button>
                  </form>
                </div> : null}
                {
                  submitFormGame && showFormGame ? 
                  <div>
                    <br />
                    <LoadingDots />
                    <br />
                  </div> : null
                }
              </div>
            </div>
            <img src="/assets/products/B01_LIGHT_3-4_F.png" style={{width: '70%', margin: '0 auto'}}  alt="B01"/>
          </div> */}
          <hr style={{width: '80%', margin: '0 auto'}}></hr>

          <p style={{fontSize: 40, margin: '40px 20px 0px 20px', color: "#333", fontWeight: 700}}>Prix innovation Sécurité routière 2025</p>
          <br />
          <br />
          
          <div className='desktop-block-2' style={{width: '90%', margin: '0 auto'}}>
            <div
              style={{borderRadius: 28, overflow: "hidden", width: '90%', margin: '0 auto'}}
            >
              <iframe width="100%" height="315" src="https://www.youtube-nocookie.com/embed/uxGGTYpAGuU?si=85h2J-oEnfzViVdC&amp;controls=0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </div>
            <div style={{width: '45%', margin: '0 auto', borderRadius: 28, overflow: 'hidden'}}>
              <img src="/assets/other/SR-white.jpeg" alt="Logo" className="logo sécurité routière" />
            </div>
          </div>
          <br />
          <br />  
          {/* <hr style={{width: '80%', margin: '0 auto'}}></hr>
          <p style={{fontSize: 40, margin: '40px 20px 0px 20px', color: "#333", fontWeight: 700}}>Découvrir plus...</p>
          <MediaSlider /> */}
          {/* <img src="/assets/other/BO1-B01Lite.png" alt="Logo" className="comparasion" /> */}

          <br />
          <hr style={{width: '80%', margin: '0 auto'}}></hr>
          <br />
          <br />

          <p style={{fontSize: 40, margin: '0px 20px 0px 20px', color: "#333", fontWeight: 700}}>On parle de nous !</p>
          <br />

          <VideoSlider />

          <div className='desktop-block-2' style={{width: '90%', margin: '0 auto'}}>
            <MediaLogos />
            <div className="logo-lepine-container" style={{margin: '0 20px'}} >
              <img src="/assets/logos/lepine.png" alt="Logo" className="logo-lepine" />
            </div>
          </div>

          <br />
          {/* <ArticleSlider />
          <br /> */}
          {/* <VideoCard /> */}
        </div>
        {/* {B01.data && <FixedActionBar product={selectedProductB01} />} */}
      </div>
    : 
    <div className="loader-container">
      <Loader /> 
    </div>
    }
    </div>
  );
};

export default HomePage;
